import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { getExperimentCohort } from '@atlassian/generative-ai-modal/utils/experiments';
import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { sliceOrNodeToMarkdown } from '../../../config-items/slice-or-node-to-markdown';
import { aiSpellingGrammarPluginKey } from '../../../pm-plugins/ai-spelling-grammar/ai-spelling-grammar-plugin-key';
import { handleSpellingAndGrammarWithAnalytics } from '../../../pm-plugins/ai-spelling-grammar/commands-with-analytics';
import { getConfiguration as getProactiveAIConfig } from '../../../pm-plugins/ai-spelling-grammar/configuration';
import { getAllDiffObjects } from '../../../pm-plugins/ai-spelling-grammar/utils';
import { streamConvoAI } from '../../../provider/prompt-requests/convo-ai';
import { streamXPGenAI } from '../../../provider/prompt-requests/xp-gen-ai';
import { Icon as FixSpellingIcon } from '../../assets/icons/fixSpelling';
import { Icon as ImproveWritingIcon } from '../../assets/icons/improveWriting';
import { createInsertBelow, createReplace } from '../../config-item-actions/markdown';
import { isMinLength } from '../../config-item-visible/visibility-utils';
import { messages as changeToneMessages } from '../change-tone/messages';
import { messages as shortenMessages } from '../shorten/messages';
import { getSlice } from '../utils';
import { messages as enhancedMessages } from './messages';
var SELECTION_TYPE = 'range';
var createStreamTask = function createStreamTask(taskName, intentSchemaId, editorSchema, initialContext) {
  if (fg('platform_editor_ai_assistance_service')) {
    return /*#__PURE__*/function () {
      var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
        var streaming, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, streamItem;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              streaming = streamConvoAI({
                userLocale: initialContext.userLocale,
                intentSchemaId: intentSchemaId,
                editorSchema: editorSchema,
                fullDocument: initialContext.document,
                currentSelection: initialContext.selection
              })(options);
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 3;
              _iterator = _asyncIterator(streaming);
            case 5:
              _context.next = 7;
              return _awaitAsyncGenerator(_iterator.next());
            case 7:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 14;
                break;
              }
              streamItem = _step.value;
              _context.next = 11;
              return _objectSpread(_objectSpread({}, streamItem), {}, {
                name: taskName
              });
            case 11:
              _iteratorAbruptCompletion = false;
              _context.next = 5;
              break;
            case 14:
              _context.next = 20;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;
            case 20:
              _context.prev = 20;
              _context.prev = 21;
              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 25;
                break;
              }
              _context.next = 25;
              return _awaitAsyncGenerator(_iterator.return());
            case 25:
              _context.prev = 25;
              if (!_didIteratorError) {
                _context.next = 28;
                break;
              }
              throw _iteratorError;
            case 28:
              return _context.finish(25);
            case 29:
              return _context.finish(20);
            case 30:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 16, 20, 30], [21,, 25, 29]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  } else {
    return /*#__PURE__*/function () {
      var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
        var streaming, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, streamItem;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              streaming = streamXPGenAI({
                userLocale: initialContext.userLocale,
                intentSchemaId: intentSchemaId,
                editorSchema: editorSchema,
                contextList: [{
                  type: 'ADF_MARKDOWN_V1',
                  entity: initialContext.selection,
                  relationship: 'SELECTION'
                }]
              })(options);
              _iteratorAbruptCompletion2 = false;
              _didIteratorError2 = false;
              _context2.prev = 3;
              _iterator2 = _asyncIterator(streaming);
            case 5:
              _context2.next = 7;
              return _awaitAsyncGenerator(_iterator2.next());
            case 7:
              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
                _context2.next = 14;
                break;
              }
              streamItem = _step2.value;
              _context2.next = 11;
              return _objectSpread(_objectSpread({}, streamItem), {}, {
                name: taskName
              });
            case 11:
              _iteratorAbruptCompletion2 = false;
              _context2.next = 5;
              break;
            case 14:
              _context2.next = 20;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;
            case 20:
              _context2.prev = 20;
              _context2.prev = 21;
              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                _context2.next = 25;
                break;
              }
              _context2.next = 25;
              return _awaitAsyncGenerator(_iterator2.return());
            case 25:
              _context2.prev = 25;
              if (!_didIteratorError2) {
                _context2.next = 28;
                break;
              }
              throw _iteratorError2;
            case 28:
              return _context2.finish(25);
            case 29:
              return _context2.finish(20);
            case 30:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 16, 20, 30], [21,, 25, 29]]);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  }
};
var tasks = [{
  taskName: shortenMessages.title,
  intentSchemaId: 'shorten_intent_schema.json'
}, {
  taskName: enhancedMessages.fixSpellingGrammarTitle,
  intentSchemaId: 'grammar_spelling_intent_schema.json'
}, {
  taskName: changeToneMessages.professionalToneTitle,
  intentSchemaId: 'change_tone_professional_intent_schema.json'
}];
function createEnhanceOption(_ref3) {
  var key = _ref3.key,
    title = _ref3.title,
    description = _ref3.description,
    actions = _ref3.actions,
    intentSchemaId = _ref3.intentSchemaId,
    icon = _ref3.icon,
    getBackendModel = _ref3.getBackendModel,
    onSelectForPrompt = _ref3.onSelectForPrompt;
  return createEditorPluginAIConfigItemMarkdown({
    key: key,
    title: title,
    description: description,
    selectionType: SELECTION_TYPE,
    getInitialContext: function getInitialContext(_ref4) {
      var editorView = _ref4.editorView,
        positions = _ref4.positions,
        intl = _ref4.intl,
        updateIdMap = _ref4.updateIdMap,
        mentionMap = _ref4.mentionMap;
      var selection = sliceOrNodeToMarkdown({
        slice: getSlice(editorView, positions),
        editorView: editorView,
        convertTo: 'markdown-plus',
        updateIdMap: updateIdMap,
        selectionType: SELECTION_TYPE,
        mentionMap: mentionMap
      });

      //TODO: multiPrompts experiment cleanup - editor_ai_-_multi_prompts
      if (key === CONFIG_ITEM_KEYS.IMPROVE_WRITING && editorExperiment('editor_ai_-_multi_prompts', 'test')) {
        return {
          selection: selection.markdown,
          userLocale: intl.locale,
          intentSchemaId: 'improve_quality_intent_schema.json',
          additionalIntentSchemaIds: ['shorten_intent_schema.json', 'grammar_spelling_intent_schema.json', 'change_tone_professional_intent_schema.json'],
          contentStatistics: selection.contentStatistics
        };
      }
      var document = sliceOrNodeToMarkdown({
        node: editorView.state.doc,
        editorView: editorView,
        convertTo: 'markdown-plus',
        updateIdMap: updateIdMap,
        selectionType: SELECTION_TYPE,
        mentionMap: mentionMap
      });
      return {
        selection: selection.markdown,
        document: document.markdown,
        userLocale: intl.locale,
        intentSchemaId: intentSchemaId,
        contentStatistics: selection.contentStatistics
      };
    },
    triggerPromptRequest: function triggerPromptRequest(_ref5) {
      var initialContext = _ref5.initialContext,
        editorSchema = _ref5.editorSchema,
        analyticsContext = _ref5.analyticsContext;
      if (intentSchemaId === 'improve_quality_intent_schema.json' && fg('platform_editor_ai_assistance_service')) {
        return streamConvoAI({
          aiSessionId: analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.aiSessionId,
          userLocale: initialContext.userLocale,
          intentSchemaId: 'improve_quality_intent_schema.json',
          editorSchema: editorSchema,
          fullDocument: initialContext.document,
          currentSelection: initialContext.selection
        });
      }
      if (intentSchemaId === 'grammar_spelling_intent_schema.json' && fg('platform_editor_ai_assistance_service')) {
        return streamConvoAI({
          aiSessionId: analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.aiSessionId,
          userLocale: initialContext.userLocale,
          intentSchemaId: 'grammar_spelling_intent_schema.json',
          editorSchema: editorSchema,
          fullDocument: initialContext.document,
          currentSelection: initialContext.selection
        });
      }
      return streamXPGenAI({
        userLocale: initialContext.userLocale,
        intentSchemaId: intentSchemaId,
        editorSchema: editorSchema,
        contextList: [{
          type: 'ADF_MARKDOWN_V1',
          entity: initialContext.selection,
          relationship: 'SELECTION'
        }]
      });
    },
    //TODO: multiPrompts experiment cleanup - editor_ai_-_multi_prompts
    additionalTriggerPromptRequest: function additionalTriggerPromptRequest(_ref6) {
      var initialContext = _ref6.initialContext,
        editorSchema = _ref6.editorSchema,
        analyticsContext = _ref6.analyticsContext;
      if (key === CONFIG_ITEM_KEYS.IMPROVE_WRITING && editorExperiment('editor_ai_-_multi_prompts', 'test')) {
        return /*#__PURE__*/function () {
          var _combinedStream = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
            var _i, _tasks, _tasks$_i, taskName, _intentSchemaId, streamTask, _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, streamItem;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _i = 0, _tasks = tasks;
                case 1:
                  if (!(_i < _tasks.length)) {
                    _context3.next = 36;
                    break;
                  }
                  _tasks$_i = _tasks[_i], taskName = _tasks$_i.taskName, _intentSchemaId = _tasks$_i.intentSchemaId;
                  streamTask = createStreamTask(taskName, _intentSchemaId, editorSchema, initialContext);
                  _iteratorAbruptCompletion3 = false;
                  _didIteratorError3 = false;
                  _context3.prev = 6;
                  _iterator3 = _asyncIterator(streamTask(options));
                case 8:
                  _context3.next = 10;
                  return _awaitAsyncGenerator(_iterator3.next());
                case 10:
                  if (!(_iteratorAbruptCompletion3 = !(_step3 = _context3.sent).done)) {
                    _context3.next = 17;
                    break;
                  }
                  streamItem = _step3.value;
                  _context3.next = 14;
                  return streamItem;
                case 14:
                  _iteratorAbruptCompletion3 = false;
                  _context3.next = 8;
                  break;
                case 17:
                  _context3.next = 23;
                  break;
                case 19:
                  _context3.prev = 19;
                  _context3.t0 = _context3["catch"](6);
                  _didIteratorError3 = true;
                  _iteratorError3 = _context3.t0;
                case 23:
                  _context3.prev = 23;
                  _context3.prev = 24;
                  if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                    _context3.next = 28;
                    break;
                  }
                  _context3.next = 28;
                  return _awaitAsyncGenerator(_iterator3.return());
                case 28:
                  _context3.prev = 28;
                  if (!_didIteratorError3) {
                    _context3.next = 31;
                    break;
                  }
                  throw _iteratorError3;
                case 31:
                  return _context3.finish(28);
                case 32:
                  return _context3.finish(23);
                case 33:
                  _i++;
                  _context3.next = 1;
                  break;
                case 36:
                case "end":
                  return _context3.stop();
              }
            }, _callee3, null, [[6, 19, 23, 33], [24,, 28, 32]]);
          }));
          function combinedStream(_x3) {
            return _combinedStream.apply(this, arguments);
          }
          return combinedStream;
        }();
      }
    },
    isVisible: function isVisible(_ref7) {
      var editorView = _ref7.editorView,
        positions = _ref7.positions;
      return isMinLength({
        editorView: editorView,
        minLength: 1,
        positions: positions
      });
    },
    icon: icon,
    actions: actions,
    getBackendModel: getBackendModel,
    onSelectForPrompt: onSelectForPrompt,
    get statusLozengeType() {
      if (fg('platform_editor_ai_proactive_spelling_and_grammar')) {
        var variation = getExperimentCohort('editor_ai_-_proactive_ai_spelling_and_grammar');
        if (key === CONFIG_ITEM_KEYS.FIX_SPELLING_AND_GRAMMAR && variation !== 'control' && variation !== 'not-enrolled') {
          return 'beta';
        }
      }
    }
  });
}
export var improveWriting = createEnhanceOption({
  key: CONFIG_ITEM_KEYS.IMPROVE_WRITING,
  title: enhancedMessages.improveWritingTitle,
  description: enhancedMessages.improveWritingDescription,
  actions: [createInsertBelow({
    appearance: 'secondary'
  }), createReplace({
    appearance: 'primary'
  })],
  intentSchemaId: 'improve_quality_intent_schema.json',
  icon: function icon(_ref8) {
    var shownAt = _ref8.shownAt;
    return /*#__PURE__*/React.createElement(ImproveWritingIcon, {
      shownAt: shownAt
    });
  },
  getBackendModel: function getBackendModel() {
    if (fg('platform_editor_ai_assistance_service')) {
      return 'assistance-service';
    }
    return 'xp-gen-ai';
  }
});
export var fixSpellingAndGrammar = createEnhanceOption({
  key: CONFIG_ITEM_KEYS.FIX_SPELLING_AND_GRAMMAR,
  title: enhancedMessages.fixSpellingGrammarTitle,
  description: enhancedMessages.fixSpellingGrammarDescription,
  actions: [createReplace({
    appearance: 'primary'
  })],
  intentSchemaId: 'grammar_spelling_intent_schema.json',
  icon: function icon(_ref9) {
    var shownAt = _ref9.shownAt;
    return /*#__PURE__*/React.createElement(FixSpellingIcon, {
      shownAt: shownAt
    });
  },
  getBackendModel: function getBackendModel() {
    if (fg('platform_editor_ai_assistance_service')) {
      return 'assistance-service';
    }
    return 'xp-gen-ai';
  },
  onSelectForPrompt: function onSelectForPrompt(_ref10) {
    var context = _ref10.context,
      editorView = _ref10.editorView,
      endExperience = _ref10.endExperience;
    var _getProactiveAIConfig = getProactiveAIConfig(context.aiProvider),
      isProactiveAISupported = _getProactiveAIConfig.isProactiveAISupported;
    var fullDocumentSelection = context.positions[0] === 1 && context.positions[1] === editorView.state.doc.content.size - 1;
    if (isProactiveAISupported && (context.positions[0] === context.positions[1] || fullDocumentSelection)) {
      var aiSpellingGrammarPluginState = aiSpellingGrammarPluginKey.getState(editorView.state);
      var toggleCount = aiSpellingGrammarPluginState.toggleCount,
        dismissedWords = aiSpellingGrammarPluginState.dismissedWords,
        insertionCount = aiSpellingGrammarPluginState.insertionCount,
        initialToggleState = aiSpellingGrammarPluginState.initialToggleState;
      var allDiffObjects = getAllDiffObjects(aiSpellingGrammarPluginState);
      handleSpellingAndGrammarWithAnalytics({
        proactiveToggleCount: toggleCount + 1,
        totalSuggestionsOnPage: allDiffObjects.length,
        dismissedWords: dismissedWords.size,
        insertionCount: insertionCount,
        initialToggleState: initialToggleState,
        triggeredFrom: 'aiCommandPalette',
        operationType: 'start'
      })(editorView.state, editorView.dispatch);
      endExperience();
    }
  }
});